import React from 'react'
import Header from './Components/Header'
import Education from './Components/Education'
import CareerObjective from './Components/CareerObjective'
import Projects from './Components/Projects'
// import TrainingExperience from './Components/Training_Experience'
import Skills from './Components/Skills'
import Volunteering from './Components/Volunteering'
import WorkExperience from './Components/WorkExperience'


/*
  - when i need to print the pdf i will remove bootstrap in Index.js and 
  - remove live-server(X) from (Projects, Exp, Header) Component in className
  - edit LinkedIn name
  - remove style in phone No
*/

export default function App() {
  return (
    <section className="main ">
      <Header />
      <Education />
      <CareerObjective />
      <Projects />
      {/* <TrainingExperience /> */}
      <WorkExperience />
      <Skills />
      <Volunteering />
    </section>
  )
}
